export default {
  title: '¡Gracias… ya estás a un paso!',
  message: 'Revisa tu correo electrónico. Te enviamos un mensaje para activar tu cuenta.'
}

export const en = {
  title: 'Thank you... you are one step away!',
  message: 'Check your email. We have send you a message to activate your account'
}

export const ca = {
  title: 'Gràcies... ja queda poc!',
  message: 'Comprova el teu correu electrònic. T\'hem enviat un missatge perquè activis el teu compte.'
}
